/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FeedType } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { repository } from "~/clientInstance";
import AreaTitle from "~/components/AreaTitle";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import PaperLayout from "~/components/PaperLayout";
import { useIsPageHeaderVNextEnabledOutsideOfProjects } from "~/components/RootRoutes/useIsPageHeaderVNextEnabled";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
import InternalRedirect from "../../../../components/Navigation/InternalRedirect/InternalRedirect";
interface OverviewFilterRedirectState extends DataBaseComponentState {
    redirectTo?: LinkHref;
}
interface RedirectFeedBasedOnTypeProps {
    spaceId: string;
    feedId: string;
}
interface RedirectFeedBasedOnTypeInternalProps extends RedirectFeedBasedOnTypeProps {
    isPageHeaderVNextEnabled: boolean;
}
class RedirectFeedBasedOnTypeInternal extends DataBaseComponent<RedirectFeedBasedOnTypeInternalProps, OverviewFilterRedirectState> {
    constructor(props: RedirectFeedBasedOnTypeInternalProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const id = this.props.feedId;
            const feed = await repository.Feeds.get(id);
            const spaceId = feed.SpaceId ?? this.props.spaceId;
            const redirectTo = feed.FeedType === FeedType.BuiltIn ? links.builtInRepositoryPage.generateUrl({ spaceId }) : links.editFeedPage.generateUrl({ spaceId, feedId: id });
            this.setState({ redirectTo });
        });
    }
    render() {
        const to = this.state.redirectTo;
        if (!to) {
            return this.props.isPageHeaderVNextEnabled ? (<main>
                    <SkeletonLoadingLayout errors={this.errors}/>
                </main>) : (<main>
                    <AreaTitle link={links.libraryRootRedirect.generateUrl({ spaceId: this.props.spaceId })} title="Library"/>
                    <PaperLayout busy={this.state.busy} fullWidth={true} errors={this.errors}/>
                </main>);
        }
        return <InternalRedirect push={false} to={to}/>;
    }
    static displayName = "RedirectFeedBasedOnTypeInternal";
}
export function RedirectFeedBasedOnType({ spaceId, feedId }: RedirectFeedBasedOnTypeProps) {
    const isPageHeaderVNextEnabled = useIsPageHeaderVNextEnabledOutsideOfProjects();
    return <RedirectFeedBasedOnTypeInternal spaceId={spaceId} feedId={feedId} isPageHeaderVNextEnabled={isPageHeaderVNextEnabled}/>;
}
